<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Add
      Report</a>
    <FormReport v-model="data" @submit="onSubmit" ref="formReport" />
  </main>
</template>
<script>
import FormReport from "@/components/form/report"
import axios from '@/axios';
import { showErrorMessage } from '@/utils';

export default {
  components: {
    FormReport
  },
  data() {
    return {
      data: {
        name: '',
        link: '',
        category: ''
      },
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formReport.$validator.validateAll();
      if (isValid) {
        this.$store.dispatch('toggleLoadingProgress', true)
        axios.post('/reports', this.data).then(() => {
          this.$notify({ type: 'success', text: 'Success adding report' })
          this.$router.push('/reports')
        }).catch(error => {
          showErrorMessage(error)
        }).finally(() => {
          this.$store.dispatch('toggleLoadingProgress', false)
        })
      }
    },
  }
}
</script>

<style></style>
